import { observer } from "mobx-react-lite";
import React, { type PropsWithChildren } from "react";
import { YStack } from "tamagui";
import { Box } from "../../ui/Box";
import { Label } from "../../ui/Label";
import { Title } from "../../ui/Title";
import BusinessAdminDevGate from "./BusinessAdminDevGate";

export const BusinessAdminDevView = observer(
  ({ children }: PropsWithChildren) => {
    return (
      <BusinessAdminDevGate>
        <YStack gap={"$medium"}>
          <Box>
            <Title>Dev Admin</Title>
            <Label>You are signed in!</Label>
          </Box>

          <Box>{children}</Box>
        </YStack>
      </BusinessAdminDevGate>
    );
  },
);
